import { createSelector } from 'reselect';
import { navSelector } from '.';

/**
 * @returns {( object ) => object|null} Round.
 */
export const roundLoadErrorSelector = createSelector(
    navSelector,
    (state) => state.rounds,
    (nav, rounds) => {
        try {
            return rounds[`season_${nav.season.id}`].error === true;
        } catch (err) {
            return null;
        }
    }
);
